<template>
    <div class="account-container">
        <van-tabs v-model="activeTabIndex" @rendered="handleChartsRendered" @change="handleChartsChange">
            <van-tab title="月账单">
                <div id="accountMonthlyChart" :style="{ width: '100vw', height: '30vh' }"></div>
            </van-tab>
            <van-tab title="年账单">
                <div id="accountAnnualChart" :style="{ width: '100vw', height: '30vh' }"></div>
            </van-tab>
        </van-tabs>

        <!-- 添加按钮 -->
        <div class="summary-container">
            <div class="summary">
                <div class="card">
                    <p class="title">收支汇总：</p>
                    <p class="data">{{ savingTotalFormat }}</p>
                </div>
            </div>
            <img class="account-add-btn" src="../../assets/img/account-add-btn.svg" @click="handleAddAccountBtnClick">
        </div>

        <!-- 账单明细 -->
        <van-cell-group v-for="item in allSavingList" :key="item.id">
            <van-cell class="custom-cell">
                <template #title>
                    <div>{{ item.money }}</div>
                </template>
                <template #default>
                    {{ item.recordTime }}：{{ item.remark }}
                </template>

            </van-cell>
        </van-cell-group>

        <!-- 表单 -->
        <van-dialog v-model="addAccountFormVisible" title="添加账单" show-cancel-button @cancel="handleAddAccountFormCancel"
            @confirm="handleAddAccountFormSubmit">
            <van-form ref="addAccountForm">
                <van-field v-model="addAccountFormParams.money" name="金额" label="金额" placeholder="请填写金额"
                    :rules="[{ required: true, message: '请填写金额' }]" />
                <van-field v-model="addAccountFormParams.remark" name="备注" label="备注" placeholder="请填写备注"
                    :rules="[{ required: true, message: '请填写备注' }]" />
            </van-form>
        </van-dialog>

    </div>
</template>

<script>
// 格式化为人民币
const cnyFormatter = new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency: 'CNY'
});

export default {
    data() {
        return {

            // 收支汇总
            savingTotal: null,

            // 储蓄明细列表
            allSavingList: [],



            activeTabIndex: 0,
            // 日账单图表实例对象
            accountDailyChart: null,
            // 月账单图表实例对象
            accountMonthlyChart: null,


            // 是否显示添加账单的表单
            addAccountFormVisible: false,


            // 添加账单的表单里面的参数
            addAccountFormParams: {
                money: null,
                remark: null,
            }
        }
    },
    computed: {
        savingTotalFormat() {
            return cnyFormatter.format(this.savingTotal);
        }

    },
    mounted() {
        this.queryAllSavingList();
        this.querySavingTotal();
    },
    methods: {

        // 查询储蓄总金额
        querySavingTotal() {
            let _self = this;
            _self.$api.saving
                .querySavingTotal()
                .then((res) => {
                    if (res.returnCode === 200) {
                        _self.savingTotal = res.data
                    } else {
                        _self.$toast.fail("查询收支汇总失败");
                    }
                })
                .catch((error) => {
                    _self.$toast.fail("查询收支汇总失败 " + error);
                });
        },

        // 按照月份统计过去半年每月支出的求和
        sumByMonthThePastHalfYear() {
            let _self = this;
            return new Promise((resolve, reject) => {
                _self.$api.saving
                    .sumByMonthThePastHalfYear()
                    .then(
                        res => {
                            if (res.returnCode === 200) {
                                resolve(res.data);
                            } else {
                                throw new Error("按照月份统计过去半年每月支出的求和失败");
                            }
                        },
                        error => {
                            throw new Error("按照月份统计过去半年每月支出的求和失败");
                        }
                    )
                    .catch(
                        err => {
                            throw new Error("按照月份统计过去半年每月支出的求和失败");
                        }
                    )
            });

        },

        // 查询账单明细
        queryAllSavingList() {
            let _self = this;
            _self.$api.saving
                .queryAllSavingDetail()
                .then(
                    res => {
                        if (res.returnCode === 200) {
                            _self.allSavingList = res.data.map(
                                (item) => {
                                    return item;
                                }
                            );
                        } else {
                            _self.$toast.fail(res.returnMsg);
                        }
                    },
                    error => {
                        console.log(error);
                        _self.$toast.fail("服务器忙，请稍后重试");
                    }
                )
                .catch(err => {
                    console.log(err);
                });
        },




        handleChartsChange(index) {
            // console.log("图表切换触发")
            // let _self = this;
            // // 渲染日账单图表
            // if (0 === index) {
            //     _self.drawAccountMonthlyChart();
            // } else if (1 === index) {
            //     _self.drawAccountAnnualChart();
            // }
        },


        // tab标签首次渲染的时候触发
        handleChartsRendered(index) {
            let _self = this;
            // 渲染日账单图表
            if (0 === index) {
                _self.drawAccountMonthlyChart();
            } else if (1 === index) {
                _self.drawAccountAnnualChart();
            }
        },

        // 渲染月账单图表
        drawAccountMonthlyChart() {
            let _self = this;
            this.sumByMonthThePastHalfYear()
                .then(res => {
                    // console.log(res);
                    let x = [];
                    let data = [];

                    let computeMax = 1000;// 根据返回的统计数据动态计算图表显示的上限值(如果不超过阈值1000则上限值为1500,如果超过阈值1000则最大值加500)

                    Object.keys(res).forEach(key => {
                        const value = res[key];

                        if (Math.abs(value) > computeMax) { computeMax = Math.abs(value) };

                        x.push(key.slice(2));
                        data.push(Math.abs(value));
                    });

                    computeMax += 500


                    // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
                    _self.accountMonthlyChart = _self.$echarts.init(document.getElementById('accountMonthlyChart'))
                    // 绘制图表
                    _self.accountMonthlyChart.setOption({
                        title: { text: '' },
                        tooltip: {},
                        grid: {
                            left: '3%',    // 左侧边距
                            right: '4%',   // 右侧边距
                            top: '15%',    // 顶部边距
                            bottom: '5%',  // 底部边距（关键：调小这个值即可减少下方空白）
                            containLabel: true // 确保标签包含在 grid 区域内，避免被裁剪
                        },
                        xAxis: {
                            data: x
                        },
                        yAxis: {
                            min: 0,
                            max: computeMax, // 动态计算的最大值
                        },
                        series: [{
                            name: '收支',
                            type: 'bar',
                            data: data,
                            label: {
                                show: true,
                                position: 'top',
                                textStyle: {
                                    color: 'black',
                                    fontSize: 16
                                }
                            },
                            markLine: {
                                // 阈值线整体样式
                                lineStyle: {
                                    width: 1, // 线宽加大，更突出
                                    type: 'solid'
                                },
                                // 阈值标签样式
                                label: {
                                    fontSize: 12,
                                    fontWeight: 'bold',
                                    // 标签位置：start（线的左端），可选start/center
                                    position: 'start',
                                    offset: [100, -8],
                                    formatter: `限额：{c}`,
                                },
                                symbol: ['none', 'none'], // 左端三角形，右端隐藏
                                // 仅配置一条阈值线
                                data: [
                                    {
                                        name: '限额', // 阈值标签文字
                                        yAxis: 1000, // 阈值数值（水平线）
                                        lineStyle: { color: '#FF0000' }, // 阈值线颜色
                                        label: { color: '#FF0000' } // 标签文字颜色
                                    }
                                ]
                            }
                        }],

                    })

                })
                .catch(error => {
                    console.log(error);
                });


        },
        // 渲染年账单图表
        drawAccountAnnualChart() {
            console.log("渲染年度账单图表")
        },




        // 添加账单按钮点击事件
        handleAddAccountBtnClick() {
            let _self = this;
            _self.addAccountFormVisible = true;
        },
        // 添加账单表单取消按钮点击事件
        handleAddAccountFormCancel() {
            let _self = this;
            _self.addAccountFormParams = {
                money: null,
                remark: null,
            }
            _self.addAccountFormParams = {
                money: null,
                remark: null,
            }
            _self.addAccountFormVisible = false;
        },

        // 提交账单表单
        handleAddAccountFormSubmit() {
            let _self = this;
            _self.$refs["addAccountForm"].validate()
                .then(
                    _self.$api.saving
                        .addSavingDetail(_self.addAccountFormParams)
                        .then(res => {
                            if (res.returnCode == 200) {
                                _self.$toast.success("添加成功");
                                _self.addAccountFormParams = {
                                    money: null,
                                    remark: null,
                                }
                                _self.addAccountFormVisible = false;
                                _self.queryAllSavingList();

                            } else {
                                _self.$toast.fail("添加储蓄收支明细失败, " + res.returnMsg);
                            }
                        })
                        .catch(err => {
                            _self.$toast.fail(err);
                        })
                )
                .catch(error => {
                    _self.$toast.fail("添加储蓄收支明细失败, " + error);
                });
        },
        // 提交账单表单字段重置
        addAccountFormParamsReset() {
            let _self = this;
            _self.addAccountFormParams = {
                money: null,
                remark: null,
                category: 1,
            }
        }
    },
    beforeDestroy() {
        let _self = this;
        if (_self.accountDailyChart) {
            _self.accountDailyChart.dispose();
            _self.accountDailyChart = null;
        }
        if (_self.accountMonthlyChart) {
            _self.accountMonthlyChart.dispose();
            _self.accountMonthlyChart = null;
        }
    },
}

</script>

<style scoped>
::v-deep .custom-cell .van-cell__title {
    flex-grow: 1;
}

::v-deep .custom-cell .van-cell__value {
    flex-grow: 3;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.summary-container {
    width: 100vw;
    height: 50px;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
}

.summary-container .summary {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin: 0 auto;
    width: 70%;
    color: white;
}

.summary-container .summary .card {
    width: 70%;
    height: 80%;
    border-radius: 4px;
    background: linear-gradient(45deg, #00f2fe, #4facfe);
    padding: 2px 6px;
}

.summary-container .summary .title {
    font-size: 14px;
}

.summary-container .summary .data {
    font-size: 14px;
    font-weight: 800;
}

.summary-container .account-add-btn {
    display: block;
    height: 100%;
    margin: 0 auto;
    width: 30%;
}
</style>